import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { persist, subscribeWithSelector, createJSONStorage } from 'zustand/middleware';

// Import types
import type { CalculatePricePayloadProduct } from 'types/api/packetsSubscription';
import type { Summary } from 'types/views/configurator';
import type { CalculatePriceAction } from 'types/api/packetsSubscription/calculatePrice';

type StoreValues = {
	main: CalculatePricePayloadProduct | null;
	premium: CalculatePricePayloadProduct[];
	summary: Summary | null;
	action: CalculatePriceAction | null;
};

type StoreActions = {
	setSummary: (summary: Summary | null) => void;
	setMain: (main: CalculatePricePayloadProduct, action: CalculatePriceAction) => void;
	setPremium: (premium: CalculatePricePayloadProduct, action?: CalculatePriceAction) => void;
	setPremiums: (packets: CalculatePricePayloadProduct[]) => void;
	clearSummaryStore: () => void;
};

const initial: StoreValues = {
	main: null,
	premium: [],
	summary: null,
	action: null
};

export const useSummaryStore = create<StoreValues & StoreActions>()(
	immer(
		persist(
			subscribeWithSelector((set) => ({
				...initial,
				setSummary: (summary) =>
					set((state) => {
						state.summary = summary;
					}),
				setMain: (packet, action) =>
					set((state) => {
						state.main = packet;
						state.action = action;
					}),
				setPremium: (packet, action) =>
					set((state) => {
						state.action = action ?? state.action;

						if (state.premium.some(({ uuid }) => uuid === packet.uuid)) {
							state.premium = state.premium.filter(({ uuid }) => uuid !== packet.uuid);
						} else {
							state.premium.push(packet);
						}
					}),
				setPremiums: (packets) =>
					set((state) => {
						state.premium = packets;
					}),
				clearSummaryStore: () => {
					set(initial);
				}
			})),
			{
				name: 'configurator',
				storage: createJSONStorage(() => localStorage)
			}
		)
	)
);
